import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type UploadPhoto = {
  formData: FormData;
};

type ConfirmEmailResponse = {
  message: string;
  confirmationCode: string;
};

export type UploadPhotoParams = RequestConfig<UploadPhoto>;

export const uploadPhoto = async ({ params, config }: UploadPhotoParams) =>
  api.post<ConfirmEmailResponse>(`/api/photos/upload`, params.formData, config);
